import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { paramCheck, requiredParamsCheck } from '../../utils';

export interface ReadBLECharacteristicValueOption
  extends Partial<GeneralInvokeOption> {
  deviceId: string;
  serviceId: string;
  characteristicId: string;
  invalidParamObj?: '';
}

// 读取蓝牙低功耗设备特征值的二进制数据。注意：必须设备的特征支持 read 才可以成功调用
export function readBLECharacteristicValue(
  option: ReadBLECharacteristicValueOption
) {
  if (
    !requiredParamsCheck(
      {
        deviceId: option.deviceId,
        serviceId: option.serviceId,
        characteristicId: option.characteristicId
      },
      option,
      APINames.Native.READ_BLE_CHARACTERISTIC_VALUE
    )
  ) {
    return option.invalidParamObj;
  }
  if (
    paramCheck(APINames.Native.READ_BLE_CHARACTERISTIC_VALUE, option, {
      deviceId: '',
      serviceId: '',
      characteristicId: ''
    })
  ) {
    return MacleJSBridge.beforeInvoke(
      APINames.Native.READ_BLE_CHARACTERISTIC_VALUE,
      option
    );
  }
  return option.invalidParamObj;
}
